// extracted by mini-css-extract-plugin
export default {"cylindoRotateHint":"I8qrB","viewUpdated":"MidXE","arrowPrev":"mOFPY","arrowNext":"s8qof","text":"uj0yS","sizeS":"bJLG6","sizeM":"n6PDt"};